<div class="w-full bg-white p-3 md:p-5">
  <div class="flex flex-column md:flex-row justify-content-between align-items-start md:align-items-center mb-4 gap-3">
    <div>
      <h2 class="text-2xl font-bold m-0 text-900">Finanzas Web</h2>
      <p class="text-500 m-0 text-sm mt-1">Cobros, comisiones y pagos web.</p>
    </div>
    <div class="flex align-items-center gap-2 flex-wrap">
      <p-datepicker
        [(ngModel)]="rangeDates"
        selectionMode="range"
        [readonlyInput]="true"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        placeholder="Rango de fechas"
        (onClose)="onRangeChange()"
        appendTo="body"
        inputStyleClass="text-sm"
        [style]="{'min-width':'240px'}">
      </p-datepicker>
      <button pButton icon="pi pi-refresh" class="p-button-outlined" (click)="loadStats()" pTooltip="Actualizar"></button>
    </div>
  </div>

  <div class="grid" *ngIf="!loading && stats; else loadingTpl">
    <div class="col-12 md:col-6 lg:col-3">
      <div class="surface-card shadow-1 p-3 border-round kpi-card border-left-3 border-blue-500 h-full">
        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-semibold mb-2">Cobrado web</span>
            <div class="text-900 font-bold text-2xl">{{ stats.cobradoWeb | currency:'PEN':'symbol' }}</div>
          </div>
          <div class="kpi-icon bg-blue-50"><i class="pi pi-wallet text-blue-500 text-xl"></i></div>
        </div>
        <span class="text-blue-600 font-medium text-sm">{{ stats.cobradoWebCount }} pedidos</span>
      </div>
    </div>

    <div class="col-12 md:col-6 lg:col-3">
      <div class="surface-card shadow-1 p-3 border-round kpi-card border-left-3 border-orange-500 h-full"
           pTooltip="Saldo de pedidos confirmados" tooltipPosition="top">
        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-semibold mb-2">Por cobrar</span>
            <div class="text-900 font-bold text-2xl">{{ stats.porCobrar | currency:'PEN':'symbol' }}</div>
          </div>
          <div class="kpi-icon bg-orange-50"><i class="pi pi-hourglass text-orange-500 text-xl"></i></div>
        </div>
        <span class="text-orange-600 font-medium text-sm">{{ stats.porCobrarCount }} pedidos</span>
      </div>
    </div>

    <div class="col-12 md:col-6 lg:col-3">
      <div class="surface-card shadow-1 p-3 border-round kpi-card border-left-3 border-green-500 h-full">
        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-semibold mb-2">Tasa aprobación</span>
            <div class="text-900 font-bold text-2xl">{{ stats.tasaAprobacion | number:'1.1-1' }}%</div>
          </div>
          <div class="kpi-icon bg-green-50"><i class="pi pi-check-circle text-green-500 text-xl"></i></div>
        </div>
        <span class="text-green-600 font-medium text-sm">{{ stats.embudoAprobados }} aprob. / {{ stats.embudoRechazados }} rech.</span>
      </div>
    </div>

    <div class="col-12 md:col-6 lg:col-3">
      <div class="surface-card shadow-1 p-3 border-round kpi-card border-left-3 border-cyan-500 h-full">
        <div class="flex justify-content-between mb-3">
          <div>
            <span class="block text-500 font-semibold mb-2">Ticket prom. web</span>
            <div class="text-900 font-bold text-2xl">{{ stats.ticketPromedioWeb | currency:'PEN':'symbol' }}</div>
          </div>
          <div class="kpi-icon bg-cyan-50"><i class="pi pi-shopping-cart text-cyan-500 text-xl"></i></div>
        </div>
        <span class="text-cyan-600 font-medium text-sm">{{ stats.ticketWebCount }} pedidos</span>
      </div>
    </div>

    <div class="col-12">
      <div class="surface-card shadow-1 p-4 border-round">
        <h5 class="text-lg font-bold m-0 mb-3 text-900">Comisiones MercadoPago</h5>
        <div class="grid">
          <div class="col-6 md:col-3">
            <span class="block text-500 text-sm">Bruto</span>
            <span class="text-xl font-bold text-900">{{ stats.cobradoWeb | currency:'PEN':'symbol' }}</span>
          </div>
          <div class="col-6 md:col-3">
            <span class="block text-500 text-sm">Comisión</span>
            <span class="text-xl font-bold text-orange-600">{{ stats.comisionMp | currency:'PEN':'symbol' }}</span>
          </div>
          <div class="col-6 md:col-3">
            <span class="block text-500 text-sm">Neto</span>
            <span class="text-xl font-bold text-green-600">{{ stats.netoWeb | currency:'PEN':'symbol' }}</span>
          </div>
          <div class="col-6 md:col-3" pTooltip="Sobre cobros MercadoPago" tooltipPosition="top">
            <span class="block text-500 text-sm">% comisión</span>
            <span class="text-xl font-bold text-900">{{ stats.comisionMpPct | number:'1.2-2' }}%</span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="surface-card shadow-1 p-4 border-round">
        <div class="flex justify-content-between align-items-center mb-3">
          <h5 class="text-xl font-bold m-0 text-900">Cobrado vs pedidos creados</h5>
          <span class="text-500 text-sm">{{ stats.from }} → {{ stats.to }}</span>
        </div>
        <div class="chart-container">
          <p-chart type="bar" [data]="seriesChart" [options]="chartOptions"></p-chart>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-4">
      <div class="surface-card shadow-1 p-4 border-round h-full">
        <h5 class="text-lg font-bold m-0 mb-3 text-900">Embudo de pago</h5>
        <div class="chart-container-sm">
          <p-chart type="doughnut" [data]="embudoChart" [options]="countPieOptions"></p-chart>
        </div>
        <div class="flex justify-content-between mt-3 text-sm">
          <span class="text-500">Pendientes</span>
          <span class="font-bold">{{ stats.embudoPendientes }}</span>
        </div>
        <div class="flex justify-content-between text-sm">
          <span class="text-500">Aprobados</span>
          <span class="font-bold text-green-600">{{ stats.embudoAprobados }}</span>
        </div>
        <div class="flex justify-content-between text-sm">
          <span class="text-500">Rechazados</span>
          <span class="font-bold text-red-500">{{ stats.embudoRechazados }}</span>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-4">
      <div class="surface-card shadow-1 p-4 border-round h-full">
        <h5 class="text-lg font-bold m-0 mb-3 text-900">Mix método</h5>
        <div class="chart-container-sm" *ngIf="stats.mixMetodo.length; else emptyMetodo">
          <p-chart type="doughnut" [data]="mixMetodoChart" [options]="pieOptions"></p-chart>
        </div>
        <ng-template #emptyMetodo>
          <p class="text-500 text-sm m-0">Sin cobros en el período.</p>
        </ng-template>
      </div>
    </div>

    <div class="col-12 md:col-4">
      <div class="surface-card shadow-1 p-4 border-round h-full">
        <h5 class="text-lg font-bold m-0 mb-3 text-900">Mix canal</h5>
        <div class="chart-container-sm" *ngIf="stats.mixCanal.length; else emptyCanal">
          <p-chart type="doughnut" [data]="mixCanalChart" [options]="pieOptions"></p-chart>
        </div>
        <ng-template #emptyCanal>
          <p class="text-500 text-sm m-0">Sin cobros en el período.</p>
        </ng-template>
        <p-table *ngIf="stats.mixCanal.length" [value]="stats.mixCanal" styleClass="p-datatable-sm mt-3">
          <ng-template pTemplate="header">
            <tr>
              <th>Canal</th>
              <th class="text-right">Monto</th>
              <th class="text-right">N°</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.name }}</td>
              <td class="text-right">{{ row.amount | currency:'PEN':'symbol' }}</td>
              <td class="text-right">{{ row.count }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="surface-card shadow-1 p-4 border-round">
        <h5 class="text-lg font-bold m-0 mb-3 text-900">Tickets promedio</h5>
        <div class="flex justify-content-between align-items-center mb-3 p-3 surface-50 border-round">
          <div>
            <span class="block text-500 text-sm">Web</span>
            <span class="text-xl font-bold text-900">{{ stats.ticketPromedioWeb | currency:'PEN':'symbol' }}</span>
          </div>
          <p-tag severity="info" [value]="(stats.ticketWebCount || 0) + ' pedidos'"></p-tag>
        </div>
        <div class="flex justify-content-between align-items-center p-3 surface-50 border-round">
          <div>
            <span class="block text-500 text-sm">Manual</span>
            <span class="text-xl font-bold text-900">{{ stats.ticketPromedioManual | currency:'PEN':'symbol' }}</span>
          </div>
          <p-tag severity="secondary" [value]="(stats.ticketManualCount || 0) + ' ventas'"></p-tag>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="surface-card shadow-1 p-4 border-round">
        <h5 class="text-lg font-bold m-0 mb-3 text-900">Boletas del período</h5>
        <div class="grid" *ngIf="stats.boletas as b">
          <div class="col-6">
            <span class="block text-500 text-sm">Emitidas</span>
            <span class="text-xl font-bold text-900">{{ b.cantidadBoletas }}</span>
          </div>
          <div class="col-6">
            <span class="block text-500 text-sm">Sin enviar</span>
            <span class="text-xl font-bold text-orange-600">{{ b.cantidadSinEnviar }}</span>
          </div>
          <div class="col-6 mt-3">
            <span class="block text-500 text-sm">Total emitido</span>
            <span class="text-xl font-bold text-900">{{ b.totalEmitido | currency:'PEN':'symbol' }}</span>
          </div>
          <div class="col-6 mt-3">
            <span class="block text-500 text-sm">IGV</span>
            <span class="text-xl font-bold text-900">{{ b.totalIgv | currency:'PEN':'symbol' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loadingTpl>
    <div class="flex justify-content-center align-items-center p-6 text-500">
      <i class="pi pi-spin pi-spinner text-2xl mr-2"></i> Cargando finanzas…
    </div>
  </ng-template>
</div>
